"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgGlutenFreeFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.859 5.01c-.606.025-1.344.379-1.965 1-.513.513-.844 1.107-.957 1.64l-.637.636V10.2c0-1.38-.67-2.5-1.5-2.5-.828 0-1.5 1.12-1.5 2.5 0 .986.343 1.84.84 2.246l-.84.841V13.2c0-1.38-.67-2.5-1.5-2.5-.828 0-1.5 1.12-1.5 2.5 0 .986.343 1.84.84 2.246l-1.847 1.848-.083.094a1 1 0 0 0 1.497 1.32l1.848-1.848c.407.498 1.26.84 2.246.84 1.38 0 2.5-.671 2.5-1.5 0-.828-1.12-1.5-2.5-1.5l-.087.001.841-.84c.407.497 1.26.84 2.246.84 1.38 0 2.5-.672 2.5-1.5 0-.83-1.12-1.5-2.5-1.5h-.087l.6-.599c.548-.1 1.168-.436 1.702-.97.976-.976 1.292-2.243.707-2.828a.921.921 0 0 0-.124-.104 1 1 0 0 0-.74-.189Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgGlutenFreeFilled);
//# sourceMappingURL=SvgGlutenFreeFilled.js.map